import { createTheme } from '@fluentui/react';

// Creating a theme based on UBG branding
// The colors are based on the UBG website: https://dev.ubgretire.com
export const ubgTheme = createTheme({
  palette: {
    themePrimary: '#0067b9', // UBG blue
    themeLighterAlt: '#f3f9fd',
    themeLighter: '#d0e6f8',
    themeLight: '#a7d0f2',
    themeTertiary: '#5ba3e0',
    themeSecondary: '#1a7cc6',
    themeDarkAlt: '#005da7',
    themeDark: '#004e8d',
    themeDarker: '#003968',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  }
});
